export function getParentCategories(category, categories, parentCategories) {
    categories.forEach(item => {
        if (item._id == category.parent) {
            parentCategories.push(item)

            if (item.parent) {
                getParentCategories(item, categories, parentCategories)
            }
        }
    })

    return parentCategories;
}